import { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'
import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'
import {
  DEFAULT_STATUS_PENGIRIMAN_FILTER,
  DEFAULT_PREDIKAT_FILTER,
} from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'
import {
  PREDIKAT_LABELS,
  STATUS_PENGIRIMAN_FILTER_LABELS,
} from 'app/KinerjaShared/components/PenetapanPredikatTable/constants'
import { joinWithConjunction } from 'utils/array'

export function EmptyState() {
  // Retrieve filter values from the store
  const { nameFilter, statusPengirimanFilter, predikatFilter } =
    usePenetapanPredikatTableStore((state) => ({
      nameFilter: state.nameFilter,
      statusPengirimanFilter: state.statusPengirimanFilter,
      predikatFilter: state.predikatFilter,
    }))

  const activeFilterMessage = useMemo(() => {
    const activeFilterMessages = []
    if (nameFilter) activeFilterMessages.push(`nama “${nameFilter}”`)
    if (
      statusPengirimanFilter &&
      statusPengirimanFilter !== DEFAULT_STATUS_PENGIRIMAN_FILTER
    )
      activeFilterMessages.push(
        `status “${STATUS_PENGIRIMAN_FILTER_LABELS[statusPengirimanFilter]}”`
      )
    if (predikatFilter && predikatFilter !== DEFAULT_PREDIKAT_FILTER)
      activeFilterMessages.push(`predikat “${PREDIKAT_LABELS[predikatFilter]}”`)

    const activeFilterMessage = joinWithConjunction(activeFilterMessages)

    return activeFilterMessage || 'Data'
  }, [nameFilter, statusPengirimanFilter, predikatFilter])

  const emptyStateMessage = useMemo(() => {
    const tryAgainMessage = nameFilter
      ? 'Cek ejaan dan coba lagi.'
      : 'Coba lagi.'

    return `${activeFilterMessage} tidak ditemukan. ${tryAgainMessage}`
  }, [nameFilter, activeFilterMessage])

  return (
    <div className="text-center mt-20 mb-28">
      {/* Empty state illustration */}
      <img
        src={assetUrl('/illustrations/img-empty-search-result.png')}
        alt=""
        width="120"
        height="120"
        className="h-30 w-30 mb-6 mx-auto"
      />

      {/* Empty state message */}
      <Text className="first-letter:uppercase">{emptyStateMessage}</Text>
    </div>
  )
}
